const PRODUCT_CARD_SPLIDE_OPTIONS = {
  type: "loop",
  fixedWidth: "19%",
  gap: "var(--space-2xs)",
  arrows: false,
  pagination: false,
  drag: true,
  snap: true,
  breakpoints: {
    470: { fixedWidth: "85%" },
    768: { fixedWidth: "45%" },
  },
};

window.mountProductCardSlider = (sliderElement, overrides = {}) => {
  if (!sliderElement) return null;
  return new Splide(sliderElement, {
    ...PRODUCT_CARD_SPLIDE_OPTIONS,
    ...overrides,
  }).mount();
};

window.bindCarouselHeadingArrows = (scopeElement, splide) => {
  if (!scopeElement || !splide) return;
  const arrowsContainer = scopeElement.querySelector(".carousel-heading__arrows");
  if (!arrowsContainer) return;
  arrowsContainer
    .querySelector(".carousel-heading__arrow--prev")
    ?.addEventListener("click", () => splide.go("<"));
  arrowsContainer
    .querySelector(".carousel-heading__arrow--next")
    ?.addEventListener("click", () => splide.go(">"));
};

window.mountProductCarousel = (scopeElement, sliderElement, overrides = {}) => {
  const splide = window.mountProductCardSlider(sliderElement, overrides);
  window.bindCarouselHeadingArrows(scopeElement, splide);
  return splide;
};
